import { render, staticRenderFns } from "./GlobalSearch.vue?vue&type=template&id=c9d0591c&"
import script from "./GlobalSearch.vue?vue&type=script&lang=js&"
export * from "./GlobalSearch.vue?vue&type=script&lang=js&"
import style0 from "./GlobalSearch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports